export const uploadFile = (
  url: string,
  headers: Record<string, string>,
  file: File,
  onProgress: (event: ProgressEvent) => void = () => {},
): Promise<string> => {
  const request = new XMLHttpRequest()
  request.open('PUT', url, true)
  request.responseType = 'text'
  Object.keys(headers).forEach((key) =>
    request.setRequestHeader(key, headers[key]),
  )

  return new Promise((resolve, reject) => {
    request.addEventListener('load', (event) => {
      const { status, response } = request

      if (status >= 200 && status < 300) {
        resolve(response)
      } else {
        reject(event)
      }
    })

    request.addEventListener('error', reject)
    request.upload.addEventListener('loadstart', onProgress)
    request.upload.addEventListener('progress', onProgress)

    request.send(file.slice())
  })
}
